const firebaseConfig = {
    apiKey: "AIzaSyCTc_OjYHIm3EFn1TAoyRDZhulMqrHiWSA",
    authDomain: "travel-guruu-4362a.firebaseapp.com",
    databaseURL: "https://travel-guruu-4362a.firebaseio.com",
    projectId: "travel-guruu-4362a",
    storageBucket: "travel-guruu-4362a.appspot.com",
    messagingSenderId: "658501661503",
    appId: "1:658501661503:web:ae151cb8d5c92d70ea198a"
};

export default firebaseConfig;